import {
    renderAccount,
    renderAircraft,
    renderAirportDirectory,
    renderDispatch,
    renderOrg,
} from 'ff/common/components/FFMenuV2/MenuItems';
import fillSpace from 'ff/common/components/FFMenuV2/MenuItems/FillSpace';
import { RenderMenuParams } from 'ff/common/components/FFMenuV2/RenderMenuParams';
import { hasFliteBrief } from 'ff/common/system';

export default function RenderFliteMenu({ currentUser }: RenderMenuParams) {
    const toReturn = [renderDispatch];

    if (hasFliteBrief(currentUser)) {
        toReturn.push(renderAircraft, renderAirportDirectory);
    }

    return [
        ...toReturn,
        renderOrg,
        fillSpace.bind(null, { flex: '1' }),
        renderAccount,
    ];
}
